import script from "./ElementError.vue?vue&type=script&lang=js"
export * from "./ElementError.vue?vue&type=script&lang=js"

import "./ElementError.vue?vue&type=style&index=0&id=1ea9d5e3&lang=scss"

const __exports__ = script;

export default __exports__